import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen min-w-0 items-center justify-center bg-[#090909] px-4 py-10 text-[#F5F0E8] sm:px-5" data-testid="payment-cancel">
      <div className="max-w-lg text-center">
        <h1 className="font-display text-5xl tracking-tighter">Checkout cancelled.</h1>
        <p className="text-[#F5F0E8]/60 mt-3">No worries — your spot is still open. Only 20 total, though.</p>
        <Link to="/" className="inline-block mt-8 font-accent tracking-widest bg-[#E32636] px-8 py-3 rounded-full glow-hover hover:bg-[#ff2f40]">
          BACK TO TICKETS
        </Link>
      </div>
    </div>
  );
}
